import React from 'react';
import { TimelineItemImg } from '../../';
import ItemWithTooltip from './ItemWithTooltip';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

export default function GenericImgItem({ item, isSimple, isExpanded }: Props) {
  return (
    <ItemWithTooltip item={item}>
      <TimelineItemImg
        item={item}
        isSimple={isSimple}
        isExpanded={isExpanded}
      />
    </ItemWithTooltip>
  );
}
